var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authorization_detail_box"},[_c('img',{staticClass:"responsive-img",attrs:{"src":require("../../assets/images/chayi.png"),"alt":"描述文本"}})])
}]

export { render, staticRenderFns }